{
  "goBack": "Volver",
  "layout": {
    "offline": "Actualmente no tiene conexión."
  },
  "footer": {
    "copyright": "Derechos de autor"
  },
  "validation": {
    "fieldRequired": "Este campo es obligatorio",
    "phoneInvalid": "Please enter a valid phone number."
  },
  "form": {
    "chooseOne": "Seleccione una opción",
    "select": "Seleccionar",
    "filterBy": "Filtrar por"
  },
  "colorMode": {
    "light": "Claro",
    "dark": "Oscuro",
    "systemDefault": "Predeterminado del sistema",
    "lightThemeAlt": "tema claro",
    "darkThemeAlt": "tema oscuro",
    "systemThemeAlt": "tema del sistema"
  },
  "nav": {
    "messaging": "Mensajería Segura",
    "attachments": "Biblioteca de Archivos Adjuntos",
    "calendar": "Calendario Compartido",
    "payments": "Pagos Responsables",
    "info": "Biblioteca de Información",
    "records": "Registros Inalterables",
    "journal": "Diario Personal",
    "settings": "Configuración de la Cuenta",
    "help": "Centro de Ayuda",
    "contact": "Contáctenos",
    "signout": "Cerrar Sesión",
    "tryNewLook": "Pruebe el Nuevo Diseño!",
    "tryNewLook_sm": "Nuevo Diseño!",
    "feedback": "Envíenos sus comentarios",
    "vault": "Almacenamiento de Archivos en la Bóveda",
    "calling": "Llamadas Responsables"
  },
  "titles": {
    "messaging": "Mensajería con {name}",
    "messagingMobile": "Mensajería",
    "attachments": "Biblioteca de Archivos Adjuntos",
    "calendar": "Calendario Compartido",
    "payments": "Pagos Responsables",
    "info": "Biblioteca de Información",
    "records": "Registros Inalterables",
    "journal": "Diario Personal",
    "settings": "Configuración de la Cuenta",
    "help": "Centro de Ayuda",
    "contact": "Contáctenos",
    "vault": "Almacenamiento de Archivos en la Bóveda",
    "calling": "Llamadas Responsables"
  },
  "errorModal": {
    "header": "Algo salió mal...",
    "fixError": "Por favor corrija el error a continuación e intente de nuevo. Si el problema continúa, contáctenos en {contact}.",
    "errorText": "Error: {error}",
    "genericError": "Por favor verifique su conexión e intente de nuevo. Si el problema continúa, contáctenos en {contact}."
  },
  "characterLimitReached": "Límite de caracteres alcanzado ({over} carácter).",
  "dropzone": {
    "title": "Arrastre y suelte archivos o haga clic para explorar",
    "subtitle": "Máximo de archivos para cargar: {count} archivos, {size} cada uno",
    "mobileTitle": "Agregar archivos adjuntos | Agregar archivos adjuntos ({count}) | Agregar archivos adjuntos ({count})",
    "errors": {
      "header": "No se pudo agregar el archivo adjunto",
      "illegalCharacters": {
        "title": "No se pudo agregar el archivo adjunto porque el nombre del archivo no es válido.",
        "subtitle": "Los nombres de archivo no deben contener ninguno de los siguientes caracteres: {characters}"
      },
      "illegalExtension": {
        "title": "No se pudo agregar el archivo adjunto porque este tipo de archivo no es aceptado.",
        "subtitle": "Tipos de archivo aceptados: {types}"
      },
      "fileSizeTooBig": {
        "title": "El tamaño del archivo es demasiado grande ({size}).",
        "subtitle": "Tamaño máximo de archivo: {size}."
      },
      "tooManyFiles": "Solo puede adjuntar 5 archivos por mensaje. No puede cargar más archivos."
    }
  },
  "attachFromVault": {
    "title": "Insertar archivos desde la Bóveda",
    "upgradeModal": {
      "header": "Actualice su plan para acceder al Almacenamiento de Archivos en la Bóveda",
      "content": "Almacene de forma privada y segura una variedad de archivos. Similar al almacenamiento en la nube, puede compartir enlaces a archivos directamente desde su Bóveda.",
      "upgradeButton": "Actualizar"
    }
  },
  "serviceMark": "SM",
  "banners": {
    "upgradeBannerFreeText": "Actualice su plan",
    "upgradeBannerStandardPlan": "Actualice su plan",
    "highlightWords": "Standard, Plan Premium",
    "upgradeBannerMessageTier0": "para acceso ilimitado a todos los archivos adjuntos.",
    "upgradeBannerRecordsTier0": "a Enhanced o Ultimate para acceso ilimitado a PDF, además de tarifas con descuento en Registros Impresos.",
    "upgradeBannerRecordsTier1": "para ahorrar $10 adicionales en cada Registro Impreso.",
    "restrictedCoParent": "El otro progenitor no tiene una suscripción activa.",
    "restrictedCoParentLearnMore": "Más información"
  },
  "introPages": {
    "continue": "Continuar",
    "upgradeButton": "Actualizar"
  },
  "search": {
    "placeholder": "Buscar"
  },
  "downloads": {
    "inProgressCancelModal": {
      "header": "Cancelar descargas",
      "content": "Algunos elementos aún se están descargando. Está seguro de que desea detenerlos todos?",
      "cancelButton": "Cancelar",
      "confirmButton": "Confirmar"
    },
    "list": {
      "headerSingle": "Descargando 1 elemento",
      "headerMultiple": "Descargando {count} elementos",
      "headerSingleCompleted": "1 elemento descargado",
      "headerMultipleCompleted": "{count} elementos descargados",
      "item": {
        "issue": "Hubo un problema al descargar su archivo. Por favor intente de nuevo.",
        "completed": "Completado",
        "reDownload": "Volver a descargar"
      }
    }
  },
  "uploads": {
    "list": {
      "headerSingle": "Cargando 1 elemento",
      "headerMultiple": "Cargando {count} elementos",
      "headerSingleCompleted": "1 elemento cargado",
      "headerMultipleCompleted": "{count} elementos cargados",
      "item": {
        "converting": "Convirtiendo...",
        "issue": "Hubo un problema al cargar su archivo. Por favor intente de nuevo.",
        "pause": "Pausar",
        "resume": "Reanudar carga",
        "completed": "Completado",
        "failed": "Error"
      }
    }
  },
  "errors": {
    "existingSubscriptionTitle": "Suscripción activa existente",
    "existingSubscriptionMessage": "Su cuenta ya tiene una suscripción activa a través de TalkingParents. Por favor contacte a soporte para más asistencia."
  },
  "states": {
    "label": "Estado",
    "defaultOption": "Seleccionar",
    "errorMessage": "La selección de estado es obligatoria.",
    "al": "Alabama",
    "ak": "Alaska",
    "az": "Arizona",
    "ar": "Arkansas",
    "ca": "California",
    "co": "Colorado",
    "ct": "Connecticut",
    "de": "Delaware",
    "dc": "District of Columbia",
    "fl": "Florida",
    "ga": "Georgia",
    "hi": "Hawaii",
    "id": "Idaho",
    "il": "Illinois",
    "in": "Indiana",
    "ia": "Iowa",
    "ks": "Kansas",
    "ky": "Kentucky",
    "la": "Louisiana",
    "me": "Maine",
    "md": "Maryland",
    "ma": "Massachusetts",
    "mi": "Michigan",
    "mn": "Minnesota",
    "ms": "Mississippi",
    "mo": "Missouri",
    "mt": "Montana",
    "ne": "Nebraska",
    "nv": "Nevada",
    "nh": "New Hampshire",
    "nj": "New Jersey",
    "nm": "New Mexico",
    "ny": "New York",
    "nc": "North Carolina",
    "nd": "North Dakota",
    "oh": "Ohio",
    "ok": "Oklahoma",
    "or": "Oregon",
    "pa": "Pennsylvania",
    "ri": "Rhode Island",
    "sc": "South Carolina",
    "sd": "South Dakota",
    "tn": "Tennessee",
    "tx": "Texas",
    "ut": "Utah",
    "vt": "Vermont",
    "va": "Virginia",
    "wa": "Washington",
    "wv": "West Virginia",
    "wi": "Wisconsin",
    "wy": "Wyoming"
  },
  "searchFilterBar": {
    "buttonScreenReader": "Ordenar y filtrar",
    "search": {
      "searchButtonScreenReader": "Buscar",
      "clearButtonScreenReader": "Limpiar",
      "ariaLabel": "Buscar en el contenido del sitio"
    },
    "filter": {
      "mobileButtonScreenReader": "Filtrar por tipo",
      "desktopButton": "Tipo",
      "modalHeader": "Filtros"
    },
    "dateRange": {
      "mobileButtonScreenReader": "Filtrar por rango de fechas",
      "desktopButton": "Fecha",
      "modalHeader": "Rango de fechas",
      "subtitle": "Rango de fechas"
    },
    "sort": {
      "mobileButtonScreenReader": "Ordenar por",
      "desktopButton": "Ordenar",
      "modalHeader": "Ordenamiento",
      "subtitle": "Ordenar por"
    },
    "selectedFilters": {
      "filteringByTypeOrStartDateOnly": "Filtrando por: {filter}",
      "filteringByDateRangeOnly": "Filtrando por: {start} - {end}",
      "filteringByBothStartDate": "Filtrando por: {filter}, {start}",
      "filteringByBothRange": "Filtrando por: {filter}, {start} - {end}",
      "filterBy": "Filtrar por: {filter}",
      "sortingBy": "Ordenar por: {sort}",
      "none": "Ninguno",
      "clearAll": "Limpiar todo",
      "clearFilter": "Limpiar filtro",
      "clearSort": "Limpiar orden",
      "clearDates": "Limpiar fechas",
      "noCountFound": "No se encontraron resultados de búsqueda para {search}."
    },
    "resetButton": "Restablecer",
    "applyButton": "Aplicar"
  },
  "aiUpsell": {
    "title": "Funciones de IA",
    "description": "Asistencia impulsada por IA para mejorar su experiencia.",
    "ctaText": "Acceda con el Plan Ultimate",
    "responseLabel": "Respuesta sugerida por IA:"
  },
  "landingPage": {
    "signIn": "Iniciar sesión",
    "getStarted": "Comenzar",
    "followUs": "Síganos",
    "termsOfService": "Términos del servicio",
    "privacyPolicy": "Política de privacidad",
    "copyright": "Derechos de autor © 2012 - {year} Monitored Communications, LLC"
  },
  "notFound": {
    "title": "Página no encontrada",
    "text": "Oh no! La página que está buscando no se pudo encontrar.",
    "goHomeCta": "Ir al inicio",
    "contactUsCta": "Contáctenos",
    "logoTitle": "Ir a la página principal de TalkingParents.",
    "logoAlt": "Logotipo de TalkingParents"
  },
  "pdfDownload": {
    "title": "Registro PDF",
    "downloadSuccess": "Descargó exitosamente su Registro PDF.",
    "inputPrompt": "Ingrese el código de acceso de 6 caracteres que recibió en su correo electrónico para descargar su registro.",
    "requiredField": "indica obligatorio",
    "accessCodeLabel": "Código de acceso",
    "submitCodeCta": "Enviar"
  },
  "newsletter": {
    "signup": {
      "title": "Manténgase al día con las noticias de coparentalidad",
      "description": "Reciba consejos y trucos de coparentalidad, información de expertos de la industria, actualizaciones sobre lanzamientos de funciones y más directamente en su bandeja de entrada.",
      "requiredField": "indica obligatorio",
      "emailLabel": "Dirección de correo electrónico",
      "signUpCta": "Suscribirme"
    },
    "welcome": {
      "title": "Bienvenido a nuestra comunidad para padres en coparentalidad!",
      "description": "Ha dado el siguiente paso para facilitar su experiencia de coparentalidad. Ahora tiene acceso a Recursos para Padres que cubren una amplia variedad de temas, seminarios web de Coparentalidad y Café organizados por expertos de la industria y padres como usted, y las últimas noticias y actualizaciones relacionadas con TalkingParents.",
      "updatePreferencesDesc": "Para actualizar sus preferencias en cualquier momento, puede visitar nuestra página de configuración de suscripción.",
      "updatePreferencesCta": "Actualizar mis preferencias",
      "parentingResourcesCta": "Llevarme a recursos para padres"
    },
    "preferencesUpdated": {
      "title": "Sus preferencias se han actualizado.",
      "description": "Hemos actualizado sus preferencias como lo solicitó. Disfrute de un boletín especialmente seleccionado para usted.",
      "resourcesDescription": "Explore hoy nuestra colección de información sobre la crianza y consejos y trucos para padres."
    }
  },
  "contactUs": {
    "dropdown": {
      "label": "Por qué nos contacta?",
      "placeholder": "Seleccione un tema",
      "options": {
        "calling": "Llamadas Responsables<sup>SM</sup>",
        "free": "Gratuito",
        "timestamp": "Marca de tiempo",
        "createaccount": "Creación de cuenta",
        "signin": "Iniciar sesión",
        "payment": "Pago",
        "attachments": "Archivos adjuntos",
        "notifications": "Notificaciones",
        "records": "Registros",
        "errormessage": "Mensaje de error recibido",
        "dv": "Violencia doméstica",
        "profinquiry": "Consulta profesional",
        "suggestion": "Sugerencia",
        "event": "Evento de Coparentalidad y Café",
        "other": "Otro"
      }
    },
    "issueDescription": {
      "label": "Por favor explique su problema con más detalle",
      "hint": "Máximo 50,000 caracteres",
      "required": "Los detalles son obligatorios."
    },
    "sendCta": "Enviar",
    "submittedState": {
      "title": "Formulario enviado",
      "thanks": "Gracias por contactarnos.",
      "responseText": "Nuestro equipo de soporte le responderá a {email} dentro de dos días hábiles."
    }
  },
  "login": {
    "title": "Iniciar sesión {sr}",
    "titleSr": "en su cuenta",
    "offlineError": "Actualmente no tiene conexión.",
    "emailLabel": "Correo electrónico",
    "passwordLabel": "Contraseña",
    "forgotPasswordCta": "Olvidó su correo electrónico o contraseña?",
    "contactUsCta": "Contáctenos",
    "signupCta": "Crear una cuenta",
    "loginStatus": "Iniciando sesión...",
    "signInButton": "Iniciar sesión"
  },
  "resetPassword": {
    "title": "Restablecer contraseña {sr}",
    "updatedTitle": "Contraseña actualizada {sr}",
    "srTitle": "de su cuenta",
    "stepOne": {
      "title": "Elija una nueva contraseña para su cuenta",
      "newPassword": {
        "label": "Nueva contraseña",
        "hint": "Debe contener al menos 10 caracteres, 1 letra, 1 número y 1 carácter especial."
      },
      "verifyPassword": {
        "label": "Verificar contraseña",
        "hint": "Vuelva a ingresar su nueva contraseña",
        "noMatchError": "Las contraseñas no coinciden."
      },
      "updatePasswordCta": "Actualizar contraseña"
    },
    "stepTwo": {
      "updateSuccessText": "Su contraseña fue actualizada exitosamente.",
      "loginText": "Ahora puede iniciar sesión con su nueva contraseña.",
      "returnToLoginCta": "Volver a iniciar sesión"
    },
    "resetError": {
      "text": "Lo sentimos, este enlace de restablecimiento ha expirado o no es válido.",
      "requestNewLink": "Solicitar nuevo enlace"
    }
  },
  "forgotPassword": {
    "title": "Olvidó su correo electrónico o contraseña {sr}",
    "titleSr": "de su cuenta",
    "description": "Ingrese la dirección de correo electrónico o el número de teléfono móvil asociado con su cuenta a continuación y le enviaremos un enlace para restablecer su contraseña.",
    "email": {
      "label": "Ingrese su dirección de correo electrónico",
      "submitCta": "Enviar",
      "forgotEmailInstructions": {
        "label": "Si no recuerda qué correo electrónico utilizó",
        "stepOne": "Ingrese cualquier dirección de correo electrónico posible arriba, presionando el botón Enviar después de cada una.",
        "stepTwo": "Revise sus bandejas de entrada en busca del correo electrónico de restablecimiento de contraseña de nuestro sistema."
      }
    },
    "mobile": {
      "label": "Ingrese su número de teléfono móvil",
      "sendCodeCta": "Enviar código"
    },
    "verifyCode": {
      "description": "Enviamos un código de 6 dígitos a {phone}",
      "resentSuccess": "Código de verificación reenviado",
      "lengthError": "El código de verificación debe tener 6 dígitos"
    },
    "emailSentModal": {
      "title": "Instrucciones enviadas por correo electrónico",
      "description": "Hemos enviado instrucciones para restablecer su contraseña a su dirección de correo electrónico si fue encontrada en nuestro sistema. Por favor asegúrese de revisar su carpeta de spam o correo no deseado.",
      "okayCta": "Aceptar"
    },
    "helpCenterCta": "Necesita ayuda para iniciar sesión?"
  },
  "password": {
    "requirement": "Por favor proporcione una contraseña con al menos 10 caracteres, una letra, un número y un carácter especial.",
    "hint": "Debe contener al menos 10 caracteres, 1 letra, 1 número y 1 carácter especial.",
    "toggle": {
      "show": "Mostrar",
      "hide": "Ocultar"
    }
  },
  "accessibility": {
    "settings": "Configuración"
  },
  "common": {
    "undo": "Deshacer",
    "dateTime": {
      "formatted": "{date} a la {time} | {date} a las {time}"
    },
    "tierCard": {
      "ultimate": {
        "bullets": [
          "Minutos de llamada ilimitados",
          "50 GB de almacenamiento en la Bóveda",
          "Registros en PDF ilimitados",
          "Soporte prioritario",
          "Pago exprés",
          "Sentiment Scanner + Writing Assist℠"
        ]
      },
      "enhanced": {
        "bullets": [
          "{minutes} minutos de llamadas",
          "15 GB de almacenamiento en la Bóveda",
          "Registros en PDF ilimitados"
        ]
      },
      "essentials": {
        "bullets": [
          "{minutes} minutos de llamadas",
          "1 GB de almacenamiento en la Bóveda"
        ]
      }
    }
  },
  "notifications": {
    "professionalApprovalRequired": {
      "title": "Se requiere aprobación",
      "description": "{name} aceptó tu invitación. Revisa el acceso para completar la conexión.",
      "reviewRequest": "Revisar solicitud"
    }
  }
}
